import { stateOptions } from '../commonStateTaxData';

export const step1Questions = [
  {
    id: 'employee_first_name_middle_initial',
    title: 'First name and middle initial',
    is_required: true,
    question_type: 'short_text',
  },
  {
    id: 'employee_last_name',
    title: 'Last name',
    is_required: true,
    question_type: 'short_text',
  },
  {
    id: 'employee_ssn',
    title: 'Social Security number',
    is_required: true,
    placeholder: '9 digits',
    question_type: 'identity',
    identity_type: 'ssn',
    rules: [
      {
        category: 'regex',
        action: 'match',
        value: '^\\d{9}$',
      },
    ],
  },
  {
    id: 'street_address',
    title: 'Current mailing address',
    is_required: true,
    question_type: 'short_text',
  },
  {
    id: 'city_or_town',
    title: 'City or town',
    is_required: true,
    question_type: 'short_text',
  },
  {
    id: 'state',
    title: 'State',
    is_required: true,
    question_type: 'dropdown',
    options: stateOptions,
  },
  {
    id: 'zip_code',
    title: 'Zip code',
    is_required: true,
    question_type: 'short_text',
    placeholder: '5 digits',
    rules: [
      {
        category: 'regex',
        action: 'match',
        value: '^\\d{5}$',
      },
    ],
  },
  {
    id: 'filing_status',
    title: 'Filing status',
    is_required: true,
    question_type: 'long_multiple_choice',
    options: [
      {
        codeValue: 'single',
        shortName:
          'Single, or married but legally separated, or spouse is a nonresident alien, or filing income tax returns with a head of household status',
      },
      {
        codeValue: 'married',
        shortName: 'Married',
      },
    ],
  },
];

export const initialAllowancesQuestions = [
  {
    id: 'dependents',
    title:
      'Enter number of Nebraska personal exemptions (other than your spouse or yourself) you will claim on your Nebraska tax return. This is the number of children and dependents you will list on your Nebraska return that qualify for either the child or dependent tax credit on the federal return.',
    question_type: 'short_text',
    rules: [
      {
        category: 'regex',
        action: 'match',
        value: '^(0|[1-9][0-9]*)$',
      },
      {
        value: '100',
        action: 'lte',
        category: 'number',
      },
    ],
  },
  {
    id: 'additional_amount',
    title:
      'Additional amount, if any, you want withheld from each paycheck for Nebraska income tax withheld:',
    question_type: 'short_text',
    rules: [
      {
        category: 'regex',
        action: 'match',
        value: '^[0-9]+(.[0-9]{1,2})?$',
      },
    ],
  },
];

export const allowanceJobDescriptions2020 = [
  'You are single and have only one job; or',
  'You are married, have only one job, and your spouse does not work; or',
  "Your wages from a second job or your spouse's wages (orthe total of both for the year) are $1,500 or less",
];

export const allowanceJobDescriptions2022 = [
  'You are single and have only one job;',
  'You are single and have only one pension;',
  'You are married, have only one job, and your spouse does not work; or',
  "Your wages from a second job, or your spouse's wages (or the total of both for the year) are $1,500 or less, or you have more than one pension",
];

export const getAllowanceJobDescriptions = (version = '') => {
  switch (version) {
    case '12_2020':
      return allowanceJobDescriptions2020;
    default:
      return allowanceJobDescriptions2022;
  }
};
